import React from "react";

import Layout from "components/Layout";
import withAuth from "components/withAuth";
import { Section } from "../styles";

function Contact() {
  return (
    <Layout>
      <Section>
        <header className="App-header"></header>
      </Section>
    </Layout>
  );
}

export default withAuth(Contact, true);
